<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">會員管理</span>
          </div>
          <b-dropdown split :split-href="downloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出會員列表">
            <b-dropdown-item :href="downloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="downloadLink('ods')" target="_blank">ods</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-navbar toggleable="md">
          <b-navbar-nav>
            <b-form @submit.prevent inline class="mr-1">
              <label for="inline-form-input-username">會員帳號：</label>
              <b-form-input
                id="inline-form-input-username"
                v-model="serachUsername"
                class="mr-2"
              ></b-form-input>
            </b-form>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-form @submit.prevent inline>
              <label for="inline-form-input-name">會員名稱：</label>
              <b-form-input
                id="inline-form-input-name"
                v-model="searchName"
                class="mr-2"
              ></b-form-input>
            </b-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="mr-1">
              <b-button
                :disabled="!selectedArray.length"
                variant="danger"
                size="sm"
                @click="onClickDelete"
              >刪除會員</b-button>
            </b-nav-item>
            <b-nav-form>
              <b-form-select v-model="each" size="sm" class="float-right">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table
          id="user-table"
          bordered
          show-empty
          :empty-text="emptyText"
          hover
          :items="items"
          :fields="fields"
          :busy="isBusy"
          responsive="md"
          class="mt-2"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox
              :id="`checkbox-${data.item.id}`"
              v-model="selectedArray"
              :value="data.item.id"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(ops)="data">
            <b-link :to="`/admin/users/${data.item.id}/more`">查看會員</b-link>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="each"
          aria-controls="user-table"
          class="float-right"
        ></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
export default {
  data () {
    return {
      currentPage: 1,
      rows: 0,
      each: 10,
      searchName: '',
      serachUsername: '',
      items: [],
      isBusy: false,
      selectedArray: [],
      errorState: 'no-result'
    }
  },
  computed: {
    emptyText () {
      const state = this.errorState
      if (state === 'no-result') {
        return '尚無會員資料'
      } else if (state === 'denied') {
        return '當前權限身分無法瀏覽'
      } else {
        return '無資料'
      }
    },
    fields () {
      return [
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'username', label: '會員帳號', tdClass: 'text-center' },
        { key: 'name', label: '會員名稱', tdClass: 'text-center' },
        { key: 'tel', label: '連絡電話', tdClass: 'text-center' },
        { key: 'email', label: '電子信箱', tdClass: 'text-center' },
        { key: 'school_num', label: '學號', tdClass: 'text-center' },
        { key: 'sum', label: '消費總額', tdClass: 'text-center' },
        { key: 'delivers', label: '訂單筆數', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: this.each
      }
      if (this.searchName) {
        obj.name = this.searchName
      }
      if (this.serachUsername) {
        obj.username = this.serachUsername
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    },
    isParticalSelected () {
      return this.items.length !== 0 && this.selectedArray.length !== 0 && this.selectedArray.length !== this.items.length
    }
  },
  methods: {
    async fetch () {
      if (this.isBusy) return
      this.isBusy = true
      try {
        const { data, headers } = await this.$api.getUser(this.query)
        this.items = data
        this.rows = headers['shop-option-total'] || 0
      } catch (err) {
        // denied
        this.errorState = 'denied'
      }
      this.isBusy = false
    },
    async onClickDelete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.delUser(id))
      try {
        await Promise.all(wait)
        this.$bvToast.toast('資料已被刪除。', {
          variant: 'success',
          title: '操作成功'
        })
        this.isBusy = false
        await this.fetch()
        this.selectedArray = []
      } catch (err) {
        this.$bvToast.toast('連線失敗，資料刪除未成功。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    },
    downloadLink (format) {
      return this.$api.urlUserSheet(format)
    }
  },
  mounted () {
    this.fetch()
  },
  watch: {
    query () {
      this.fetch()
    }
  }
}
</script>
